/*
 * Abre o Sizebay a partir dos links da PDP ("Encontre seu tamanho" e
 * "Tabela de medidas"), num modal com a moldura do Figma 139:1029.
 *
 * O app ja e carregado pelo embed `try_on` e expoe window.sizebayExtension.
 * Daqui usamos apenas o que aquela API oferece:
 *   getConfig()      -> tenantId (via app proxy /apps/sizebay-api)
 *   ensureSession()  -> sid
 *   getPermalink()   -> url canonica do produto
 *   getProduct()     -> id do produto no catalogo do Sizebay
 *   generateVfrUrl() / generateSizeChart() -> url para o iframe
 *
 * Se o app nao estiver presente, ou o produto nao estiver no catalogo, o link
 * correspondente e removido em vez de abrir um modal vazio.
 *
 * ATENCAO: getConfig() passa pelo app proxy da Shopify, que NAO funciona no
 * `shopify theme dev`. Em local o boot falha e os links somem; num tema de
 * preview ou publicado funciona normalmente.
 */
(function () {
  if (window.__bsSizebayReady) return;
  window.__bsSizebayReady = true;

  var SELETOR = '[data-sizebay]';
  var estado = null;

  function pronto() {
    return window.sizebayExtension && window.sizebayExtensionReady;
  }

  async function boot() {
    if (estado) return estado;
    if (!pronto()) return null;

    var E = window.sizebayExtension;
    var raiz = document.querySelector('[data-sizebay-product]');
    if (!raiz) return null;

    try {
      var cfg = await E.getConfig();
      var tenantId = cfg && cfg.data && cfg.data.tenantId;
      if (!tenantId) return null;

      var sid = await E.ensureSession();
      var permaLink = E.getPermalink({
        domain: window.Shopify && window.Shopify.shop,
        productId: raiz.dataset.sizebayProduct
      });

      var device = E.getDeviceType();
      var prod = await E.getProduct({
        xSzbTenantId: tenantId,
        xSzbDevice: device,
        xSzbCountry: (window.Shopify && window.Shopify.country) || 'BR',
        permaLink: permaLink,
        sid: sid
      });

      var id = prod && prod.data && prod.data.id;
      if (!id) return null;

      estado = { E: E, id: id, sid: sid, tenantId: tenantId, device: device, lang: raiz.dataset.sizebayLang || 'pt' };
      return estado;
    } catch (erro) {
      console.warn('Sizebay: nao foi possivel iniciar —', erro && erro.message);
      return null;
    }
  }

  function abrirModal(url, titulo) {
    var fundo = document.createElement('div');
    fundo.className = 'bs-sizebay-modal';
    fundo.innerHTML =
      '<div class="bs-sizebay-modal__box" role="dialog" aria-modal="true" aria-label="' + titulo + '">' +
      '<button type="button" class="bs-sizebay-modal__close" aria-label="Fechar">' +
      '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>' +
      '</button>' +
      '<iframe class="bs-sizebay-modal__frame" src="' + url + '" title="' + titulo + '" allow="camera"></iframe>' +
      '</div>';

    function fechar() {
      fundo.remove();
      document.removeEventListener('keydown', aoTeclar);
      document.body.style.overflow = '';
    }
    function aoTeclar(e) { if (e.key === 'Escape') fechar(); }

    fundo.addEventListener('click', function (e) {
      if (e.target === fundo || e.target.closest('.bs-sizebay-modal__close')) fechar();
    });
    document.addEventListener('keydown', aoTeclar);
    document.body.style.overflow = 'hidden';
    document.body.appendChild(fundo);
  }

  document.addEventListener('click', async function (evento) {
    var alvo = evento.target.closest(SELETOR);
    if (!alvo) return;
    evento.preventDefault();

    var s = await boot();
    if (!s) return;

    var comum = {
      id: s.id, sid: s.sid, tenantId: s.tenantId,
      lang: s.lang, device: s.device, sizeSystem: 'BR'
    };
    var acao = alvo.dataset.sizebay;
    var url = acao === 'sizebay_chart'
      ? s.E.generateSizeChart(comum)
      : s.E.generateVfrUrl(Object.assign({ mode: 'vfr' }, comum));

    abrirModal(url, alvo.textContent.trim());
  });

  /* Produto fora do catalogo do Sizebay: tira os links em vez de deixar um
     clique que nao faz nada. */
  document.addEventListener('DOMContentLoaded', function () {
    if (!document.querySelector(SELETOR)) return;
    var tentar = function () {
      if (!pronto()) return;
      boot().then(function (s) {
        if (s) return;
        document.querySelectorAll(SELETOR).forEach(function (el) { el.hidden = true; });
      });
    };
    if (pronto()) tentar();
    else setTimeout(tentar, 2500);
  });
})();

/*
 * Reancora o botao "Experimentar Agora" na galeria.
 *
 * O app injeta `#szb-sb-tryon-btn-overlay-button` DENTRO de uma das fotos, e
 * qual delas muda com a quantidade de fotos do produto. Preso ali, no mobile
 * o botao ia embora junto com o slide, e no desktop aparecia no meio do grid
 * em vez do topo. Movendo o no para a propria galeria, ele passa a se apoiar
 * numa caixa que nao rola — o resto (qual quina em cada breakpoint) e CSS.
 *
 * Com o widget de kits do Bundlex na pagina, o app se prende a foto do card
 * da oferta (ela tambem leva `data-product-image`), entao o botao pode nascer
 * dentro do widget, fora da galeria: vale o mesmo traslado.
 *
 * Vive fora do fluxo do launcher de proposito: aquele depende do app proxy da
 * Shopify, que nao responde no `shopify theme dev`. Este so precisa do no.
 */
(function () {
  if (window.__bsTryonAnchored) return;
  window.__bsTryonAnchored = true;

  var ID = 'szb-sb-tryon-btn-overlay-button';

  function ancorar() {
    var btn = document.getElementById(ID);
    if (!btn) return false;
    if (!btn.closest('.m-main-product--media, .bx-widget')) return true;
    var galeria = document.querySelector('.m-main-product--media .m-media-gallery');
    if (!galeria) return true;
    if (btn.parentElement !== galeria) galeria.appendChild(btn);
    return true;
  }

  function observar() {
    if (ancorar()) return;
    var midia = document.querySelector('.m-main-product--media');
    var alvo = midia && (midia.closest('.shopify-section') || midia.parentElement);
    if (!alvo) return;
    var obs = new MutationObserver(function () {
      if (ancorar()) obs.disconnect();
    });
    obs.observe(alvo, { childList: true, subtree: true });
    /* o app pode demorar; sem uma trava o observer ficaria de pe a sessao toda */
    setTimeout(function () { obs.disconnect(); }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observar);
  } else {
    observar();
  }
})();
